import { darken, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '2fr 2fr 2fr 1fr',
    alignItems: 'center',
    paddingLeft: 12,
    color: 'grey',
    marginTop: 20,
    borderRadius: 12,
    marginBottom: 4,
    backgroundColor:
      theme.palette.type === 'dark'
        ? darken(theme.palette.background.default, 0.3)
        : '#f7f7f7'
  }
}))
export default useStyles
